import { Injectable } from '@angular/core';
import { find } from 'lodash';

@Injectable()
export class LayoutService {
  private _isFullscreen: boolean = false;
  private _overflow: string = '';
  private _isLandscapeEnabled: boolean = false;
  private _showSplashscreen: boolean = false;
  private _haveShownSplashscreen: boolean = false;
  private _gridScrollPosition: any = [];

  constructor() { }

  saveGridScrollPosition(id, position) {
    let obj = find(this._gridScrollPosition, { id: id });
    if (typeof obj === 'undefined') {
      this._gridScrollPosition.push({
        id, position
      });
    } else {
      obj.position = position;
    }
  }

  getGridScrollPosition(id): number {
    let obj = find(this._gridScrollPosition, { id: id });
    return typeof obj === 'undefined' ? 0 : obj.position;
  }

  get haveShownSplashscreen(): boolean {
    return this._haveShownSplashscreen;
  }
    
  set haveShownSplashscreen(haveShownSplashscreen: boolean) {
    this._haveShownSplashscreen = haveShownSplashscreen;
  }

  get showSplashscreen(): boolean {
    return this._showSplashscreen;
  }
    
  set showSplashscreen(showSplashscreen: boolean) {
    this._showSplashscreen = showSplashscreen;
  }

  get isFullscreen(): boolean {
    return this._isFullscreen;
  }
    
  set isFullscreen(isFullscreen: boolean) {
    this._isFullscreen = isFullscreen;
  }
  
  get isLandscapeEnabled(): boolean {
    return this._isLandscapeEnabled;
  }
    
  set isLandscapeEnabled(isLandscapeEnabled: boolean) {
    this._isLandscapeEnabled = isLandscapeEnabled;
  }

  get overflow(): string {
    return this._overflow;
  }
    
  set overflow(overflow: string) {
    this._overflow = overflow;
  }
}



// WEBPACK FOOTER //
// ./src/app/layout.service.ts